export default (params) => ({
  trigger: {
    name: 'image_gallery.select_visual',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      title: {
        type: 'string',
      },
      visual_type: {
        enum: [
          'image',
          'video',
        ],
      },
      sub_feature: {
        enum: [
          'image_gallery',
          'thumbnail',
        ],
      },
    },
    event: {
      name: 'select_visual',
    },
  },
});
